export default "__VITE_ASSET__6e3d7464__"